import React from 'react'
import * as styles from './xealProvides.module.scss'
import SectionWithGrid from 'common/SectionWithGrid'
import Card from 'common/Card'

export default function XealProvides({ title, grid }) {
  return (
    <SectionWithGrid
      className={styles.section}
      grid={grid}
      title={title}
      gridItem={Card}
    />
  )
}
